export default __webpack_public_path__ + "static/media/Watermelon.9169a1c4.jpg";